<template>
    <el-tabs
        class="redesign-base-tabs"
        :value="value"
        v-bind="attrs"
        v-on="listeners"
        @input="onInput"
    >
        <slot />
    </el-tabs>
</template>

<script setup lang="ts">
import { Tabs as ElTabs } from 'element-ui'
import { useAttrs, useListeners } from 'vue'

const emit = defineEmits<{
    (e: 'input', value: string): void
}>()

withDefaults(
    defineProps<{
        value: string
    }>(),
    {
        value: ''
    }
)

const attrs = useAttrs()
const listeners = useListeners()

function onInput (val: string) {
    emit('input', val)
}
</script>
